/* eslint-disable vue/no-parsing-error */
<template>
    <div>
      <div class="container-fluid">
        <CRow class="pr-2">
    <CCol col="12" xl="10" class="p-0">
      <CCard>
        <CCardBody>

   <a-card class="edit-card" style="margin:0;" :body-style="{padding:0}">
                          <span slot="title">
                            <h6 class="w-100 mb-0 text-muted">Obchod</h6>
                            <div class="orders-header-row">
                              <span class="orders-title">Objednávky</span>
                              <a-button class="d-xl-none" size="small" @click="showMobileFilter = true"><i class="fas fa-filter mr-1"></i> Filter</a-button>
                            </div>
                          </span>
                            <span slot="extra">
        <span class="text-muted " v-if="!loading">Výsledkov: <span class="text-bold">{{totalOrders}}</span></span>
        <span  class="text-muted ml-3 d-none d-md-inline" v-if="filteredprice > 0">Suma prijatá: <span class="text-bold">{{filteredprice.toLocaleString()}} €</span></span>
        <span  class="text-muted ml-3 d-none d-md-inline" v-if="filteredabbprice > 0">Opustené/na platbe: <span class="text-bold">{{filteredabbprice.toLocaleString()}} €</span></span>
        <a-popconfirm
            v-if="bonusEnabled && unsyncedOrders.length"
            placement="bottomRight"
            okText="Áno, doposlať"
            cancelText="Zrušiť"
            @confirm="resendAllUnsynced"
        >
            <template slot="title">
                Doposlať {{ unsyncedOrders.length }} nenapojených objednávok do BONUSu? Volania prebehnú postupne.
            </template>
            <a-button class="ml-3" size="small" type="primary" :loading="bulkResending">
                <i class="fas fa-cloud-upload-alt mr-1"></i>
                Doposlať všetky nenapojené ({{ unsyncedOrders.length }})
            </a-button>
        </a-popconfirm>

                            </span>
<a-tabs v-model="activeTab">
  <a-tab-pane key="orders" tab="Objednávky">
                            <a-table
                                    :columns="columns"
                                    :dataSource="data"
                                     :pagination="pagination"
                                    :row-selection="rowSelection"
                                    size="small"
                                    :loading="loading"
                                    :rowKey="record => record.order_id"
                                    @change="handleTableChange"
                                    :scroll="{ x: 1100 }"
                                    class="table-flush">
                                <div
                                        slot="filterDropdown"
                                        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                                        style="padding: 8px;"
                                >
                                    <a-input
                                            v-ant-ref="c => searchInput = c"
                                            :placeholder="`Search ${column.dataIndex}`"
                                            :value="selectedKeys[0]"
                                            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                                            @pressEnter="() => handleSearch(selectedKeys, confirm)"
                                            style="width: 188px; margin-bottom: 8px; display: block;"
                                    />
                                    <a-button
                                            type="primary"
                                            @click="() => handleSearch(selectedKeys, confirm)"
                                            icon="search"
                                            size="small"
                                            style="width: 90px; margin-right: 8px"
                                    >Search
                                    </a-button
                                    >
                                    <a-button @click="() => handleReset(clearFilters)" size="small" style="width: 90px"
                                    >Reset
                                    </a-button
                                    >
                                </div>
                                <a-icon
                                        slot="filterIcon"
                                        slot-scope="filtered"
                                        type="search"
                                        :style="{ color: filtered ? '#108ee9' : undefined }"
                                />
                                <template slot="customRender" slot-scope="text">
      <span v-if="searchText">
        <template
                v-for="(fragment, i) in text.toString().split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))"
        >
          <mark
                  v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                  :key="i"
                  class="highlight"
          >{{fragment}}</mark
          >
          <template v-else>{{fragment}}</template>
        </template>
      </span>
                                    <template v-else
                                    >{{text}}
                                    </template
                                    >
                                </template>
                                <template slot="user_role" slot-scope="user">
                                    <a class="text-left text-lowercase" :href="'role/'+ role" :key="index" v-for="(role,index) in JSON.parse(user.type_id)"> {{roleops[role]}}<span
                                            v-if="index+1 < JSON.parse(user.type_id).length">, </span></a>
                                </template>
                                <template slot="products" slot-scope="products,record">
<template v-for="(product,ind) in record.abandoned">
                                    <div :key="ind" v-if="products[0].type === false" title="Produkt odstránený"  :class="'abandoned item-' + ind">
                                    {{product}}</div></template>
                                    <div :key="ind" v-for="(product,ind) in products" :class="'product item-' + ind">

                                        <div v-if="product.cttt !== 'voucher'">
                                            <h4 :class="'type-' + product.cttt"><b v-if="product.count > 1">{{product.count}} x </b><router-link class="text-dark" :to="'/edit-content/' + product.id">{{product.title}}</router-link>
                                            <a v-if="product.url" :href="product.siteUrl + '/' + product.language + '/' + product.url"  target="_blank" class="ml-2"  style="font-size:10px; color:#777;" ><template><i class="fas fa-external-link-alt"></i></template></a></h4>
                                           <small> <template v-if="product.data.distribution_datas">{{ product.data.distribution_datas }}</template> {{product.data.ean}} <template v-if="product.data.skladombb">- {{ product.data.skladombb }}</template>
                                             <template v-if="product.data.sklad">- {{ product.data.sklad }}</template></small>

                                        </div>
                                        <div v-else>
                                            <h4 v-if="product.formtype === 'pobytovy'" color="volcano" :key="product.cttt">
                                                Pobytový voucher
                                            </h4>
                                            <h4 v-if="product.formtype === 'wellness'" color="geekblue" :key="product.cttt">
                                                Wellness voucher
                                            </h4>
                                            <h4 v-if="product.formtype === 'namieru' || product.formtype === null" color="green" :key="product.cttt">
                                                Voucher na mieru
                                            </h4>
                                        </div>
                                    </div>
                                </template>
                                <template slot="phones" slot-scope="phone,record">
                                   <a :href="'mailto:' + record.email" class="mr-2 color-dark fs-18"><i class="far fa-envelope"></i></a>
                                   <a :href="'tel:' + phone"  class="fs-16 color-dark"><i class="fas fa-mobile-alt"></i></a>
                                </template>

                                <template slot="namevo" slot-scope="phone,record">
                                  <template v-if="record.vo == '1'"><div class="text-black" title="VO predaj">{{ record.billing_company }}</div><div class="text-muted">{{phone}}</div></template><div v-else>{{phone}}</div>
                                </template>

                                  <template slot="shipping" slot-scope="shipping,record">
                                    <template v-if="shipping && shipping.shipment != null">
                                        <template v-if="String(shipping.shipment).length == 1">Osobný odber</template>
                                        <template v-if="shipping.shipment == 'sps-parcel-shop'">Balíkovo</template>
                                        <template v-if="record.payment_method == 'cod'"><div>Dobierka</div></template>
                                        <template v-if="shipping.shipment == 'packeta-5' || shipping.shipment == 'packeta-10' || shipping.shipment == 'packeta-15'">Packeta</template>
                                        <template v-if="shipping.shipment == 'dpd-5'">DPD</template>
                                        <template v-if="shipping.shipment == 'cod'">Osobný odber</template>
                                        <template v-if="shipping.shipment == 'balikadresa-5' || shipping.shipment == 'balikadresa-10' || shipping.shipment == 'balikadresa-15'">Balík na adresu</template>
                                        <template  v-if="shipping.shipment == 'balikposta-5' || shipping.shipment == 'balikposta-10' || shipping.shipment == 'balikposta-15'">Slovenská pošta</template>
                                        <template v-if="isUnknownShipment(shipping, record)">{{ shippingLabelFallback(shipping) }}</template>
                                        <div v-if="shipping.tracking && record.order_status != 'completed'" class="mt-2"><a-tag  color="darkblue" ><a :href="shipping.tracking" target="_blank">tracking</a></a-tag></div>
                                    </template>
                                    <template v-else-if="record && record.payment_method == 'cod'"><div>Dobierka</div></template>
                                    <span v-else class="text-muted">-</span>
                                </template>
                                <template slot="field_4" slot-scope="text">
                                     <a-popover v-if="text" >
                                        <template slot="content">
                                          <span v-html="text"></span>
                                        </template>
                                        <a-button type="secondary" size="small">
                                          <i class="fas fa-align-center"></i>
                                        </a-button>
                                    </a-popover>

                                </template>
                                <template slot="status" slot-scope="payment, record">
                                    <div>
                                        <!-- Platba kartou > 1h bez prijatej platby = opustená -->
                                        <template v-if="isEffectivelyAbandoned(record)">
                                            <a-tag>Opustená</a-tag>
                                        </template>
                                        <template v-else>
                                            <a-tag v-if="payment === 'pending'" color="blue">
                                                Objednávka
                                            </a-tag>
                                            <a-tag v-if="payment === 'payment_recieved'"  color="orange">
                                                Prijatá platba
                                            </a-tag>
                                            <a-tag v-if="payment === 'in_checkout'"  color="">
                                                Platobná brána
                                            </a-tag>
                                            <a-tag v-if="payment === 'storno'"  color="red">
                                             Stornovaná
                                            </a-tag>
                                            <a-tag v-if="payment === 'abandoned'"  >
                                                Opustená
                                            </a-tag>
                                            <a-tag v-if="payment === 'shiped'"  color="red">
                                                Odoslaná
                                            </a-tag>
                                            <a-tag v-if="payment === 'instock'"  color="">
                                                Naskladnené
                                            </a-tag>

                                            <a-tag v-if="payment === 'completed'"  color="green">
                                                Kompletná
                                            </a-tag>

                                            <!-- Fallback pre neznámy/nemapovaný stav, aby stĺpec nebol prázdny -->
                                            <a-tag v-if="payment && !knownStatuses.includes(payment)">
                                                {{ payment }}
                                            </a-tag>
                                            <a-tag v-if="!payment" color="">
                                                -
                                            </a-tag>
                                        </template>
                                    </div>
                                </template>
                                <template slot="crm" slot-scope="text, record">
                                    <div v-if="record">
                                        <!-- Už napojená na BONUS -->
                                        <template v-if="record.bis_synced == 1">
                                            <a-tag color="cyan" :title="'Doklad: ' + record.bis_doklad_id">
                                                V BONUSe
                                            </a-tag>
                                        </template>

                                        <!-- Nenapojená na BONUS (opustené objednávky ignorujeme) -->
                                        <template v-else-if="record.order_status !== 'abandoned' && !isEffectivelyAbandoned(record)">
                                            <a-tag color="orange" style="cursor:pointer;" title="Zobraziť diagnostiku" @click="showDiagnostics(record.order_id)">
                                                Nie je v BONUSe <i class="fas fa-search ml-1"></i>
                                            </a-tag>
                                            <!-- Platba kartou bez prijatej platby - doposlanie nedáva zmysel -->
                                            <div class="mt-1" v-if="canResendToBis(record)">
                                                <a-button
                                                    size="small"
                                                    type="primary"
                                                    :loading="isResending(record.order_id)"
                                                    @click="resendToBis(record, false)"
                                                >
                                                    Doposlať
                                                </a-button>
                                            </div>
                                        </template>
                                    </div>
                                </template>  <template slot="payment" slot-scope="payment">
                                    <div>
                                            <a-tag v-if="payment === 'cod'" color="">Dobierka</a-tag>
                                            <a-tag v-if="payment === 'payout'"  color="green">Platba kartou</a-tag>
                                            <a-tag v-if="payment === 'cardpay'"  color="green">Platba kartou</a-tag>
                                            <a-tag v-if="payment === 'webpay'"  color="green">Platba kartou</a-tag>
                                            <a-tag v-if="payment === 'tatrapayplus'"  color="green">Platba kartou</a-tag>
                                            <a-tag v-if="payment === 'bank'"  color="red">Bankový prevod</a-tag>
                                            <a-tag v-if="payment === 'paylater'"  color="purple">Platba na splátky</a-tag>
                                    </div>
                                </template>
<template slot="invoice" slot-scope="invoice">
<template v-if="invoice">
<a :href="url.API_URL + '/../../' + invoice.invoice" target="_blank"><a-button size="small" v-if="invoice">FA{{ invoice.invoice_number }}</a-button></a>
</template>
</template>
                                <template slot="prices" slot-scope="price, record">
                                    <div v-if="price>0">{{Number(price).toFixed(2) + ' €'}}</div>
                                    <div v-if="record.transaction" class="paid" title="nastavená záloha">({{Number(record.transaction.amount).toFixed(2) + ' €'}})</div>
                                </template>
                                <template slot="date" slot-scope="datedata">
                                    <span>{{formatDate(datedata)}}</span>
                                </template>
                                <template slot="name" slot-scope="user">
                                    <router-link :to="'/order/' + user.order_id"><a-button type="secondary">Detail</a-button></router-link>

                                   </template>
                            </a-table>
                             <div style="bottom:0" class="action-panel w-25 m-3 float-left"  v-if="rowSelection.selectedRowKeys.length > 0">
                              <a-select style="width:150px;"  class="mr-3" size="small" placeholder="Vyberte si akciu" v-model="action" :options="actions"></a-select>
                              <a-popconfirm placement="topRight"
                                            @confirm="doAction"
                                            okText="Áno"
                                            cancelText="Nie"
                              >
                                  <template slot="title">
                                      <h5 color="danger" >Prajete si vykonať tento príkaz?</h5>
                                      Príkaz ovplyvní {{rowSelection.selectedRowKeys.length}} <span v-if="rowSelection.selectedRowKeys.length === 1">stránku</span> <span v-if="rowSelection.selectedRowKeys.length > 1 && rowSelection.selectedRowKeys.length < 5">stránky</span> <span v-if="rowSelection.selectedRowKeys.length > 4">stránok</span>.
                                  </template>
                                 <a-button type="warning" :loading="loadingExport">Vykonať</a-button>
                              </a-popconfirm>
                          </div>
                          </a-tab-pane>

                        <a-tab-pane key="pick" tab="Na vybavenie (produkty)">
 <div class="pick-orders-wrap">
 <a-table
  :columns="pickOrderColumns"
  :dataSource="pickOrders"
  :rowKey="record => String(record.order_id)"
  :expandedRowKeys="pickExpandedKeys"
  @expandedRowsChange="onPickExpandedChange"
  size="small"
  :pagination="{ pageSize: 200 }"
  :loading="loading"
  :scroll="{ x: 900 }"
  class="table-flush"
>

<template slot="pickContact" slot-scope="phone, record">
  <div>{{ phone || '—' }}</div>
  <div style="font-size:11px; color:#666;">
    <template v-if="record.email" >{{ record.email }}</template>
    <span v-else>—</span>
  </div>
</template>
    <!-- expanded = produkty pod objednávkou -->
    <template slot="expandedRowRender" slot-scope="record">
      <a-table
        :columns="pickProductColumns"
        :dataSource="orderProductRows(record)"
        :rowKey="row => row._pickKey"
        size="small"
        :pagination="false"
        class="nested-products-table"
      >

        <template slot="picked" slot-scope="v, row">
          <a-checkbox
            :checked="isPicked(row._pickKey)"
            @change="e => setPicked(row._pickKey, e.target.checked)"
          />
        </template>
<template slot="ean" slot-scope="v, row">
  <span>{{ row.ean || '—' }}</span>
</template>

<template slot="sklad" slot-scope="v, row">
  <span>{{ row.sklad || '—' }}</span>
</template>

<template slot="skladombb" slot-scope="v, row">
  <span>{{ row.skladombb || '—' }}</span>
</template>

        <template slot="product" slot-scope="v, row">
          <div>
            <b v-if="row.count > 1">{{ row.count }} x </b>
            <router-link class="text-dark" :to="'/edit-content/' + row.id">
              {{ row.title }}
            </router-link>

            <a
              v-if="row.url"
              :href="row.siteUrl + '/' + row.language + '/' + row.url"
              target="_blank"
              class="ml-2"
              style="font-size:10px; color:#777;"
            ><i class="fas fa-external-link-alt"></i></a>
          </div>
        </template>
      </a-table>
    </template>

    <!-- stĺpce objednávky -->
    <template slot="pickShipping" slot-scope="v, record">
      <div>{{ record.shippingLabel }}</div>
      <div v-if="record.shippingVariant" style="font-size:11px; color:#666;">{{ record.shippingVariant }}</div>
      <div v-if="record.shippingVariantID" style="font-size:11px; color:#666;">ID: {{ record.shippingVariantID }}</div>
      <div v-if="record.tracking" class="mt-1">
        <a-tag color="darkblue"><a :href="record.tracking" target="_blank">tracking</a></a-tag>
      </div>
    </template>
    <template slot="pickInvoice" slot-scope="inv, record">
  <template v-if="record.invoice && record.invoice.invoice">
    <a
      :href="invoiceUrl(record.invoice.invoice)"
      target="_blank"
    >
      <a-button size="small">FA{{ record.invoice.invoice_number }}</a-button>
    </a>
  </template>
  <span v-else>—</span>
</template>

<template slot="pickPickup" slot-scope="v, record">
  <div v-if="record.shippingVariant">{{ record.shippingVariant }}</div>
  <div v-if="record.shippingVariantID" style="font-size:11px; color:#666;">
    ID: {{ record.shippingVariantID }}
  </div>
  <div v-if="record.tracking" class="mt-1">
    <a-tag color="darkblue"><a :href="record.tracking" target="_blank">tracking</a></a-tag>
  </div>
  <span v-if="!record.shippingVariant && !record.shippingVariantID && !record.tracking">—</span>
</template>

    <template slot="pickStatus" slot-scope="v">
      <a-tag v-if="v === 'pending'" color="blue">Objednávka</a-tag>
      <a-tag v-else-if="v === 'payment_recieved'" color="orange">Prijatá platba</a-tag>
      <a-tag v-else>{{ v }}</a-tag>
    </template>

    <template slot="pickCreated" slot-scope="v">
      <span>{{ formatDate(v) }}</span>
    </template>

    <template slot="pickPrice" slot-scope="v">
      <span v-if="v > 0">{{ Number(v).toFixed(2) }} €</span>
    </template>
 <template slot="pickOrderId" slot-scope="order_id, record">
  <router-link :to="'/order/' + record.order_id">
    {{ record.order_id }}
  </router-link>
</template>

    <template slot="pickActions" slot-scope="v, record">
      <router-link :to="'/order/' + record.order_id">
        <a-button size="small">Detail</a-button>
      </router-link>
    </template>
  </a-table>
 </div>
</a-tab-pane>


</a-tabs>
                        </a-card>
                   </CCardBody>
                   </CCard>
                   </CCol>

                  <CCol col="12" xl="2" class="pl-0 pl-lg-0 filter-col d-none d-xl-block">
    <CCard class="p-0 filter-side">
        <CCardBody>

          <div class="filter-panel">
            <div class="filter-head">
              <span class="filter-title">Filter</span>
              <a-button size="small" @click="handleFilter">Filtrovať</a-button>
            </div>
                          <div class="p-2">
                <div class="col">
        <div id="components-form-demo-advanced-search"> <a-form class="ant-advanced-search-form" :form="form"  @submit="handleFilter">
      <a-row :gutter="24">
        <a-col :span="24" style="block">
            <a-form-item label="Rok" :hasFeedback="false">
                        <a-select type="text"
                        v-decorator="[
                `selectedYear`,
                { initialValue: selectedYear }
              ]" >
                            <template v-for="year in exposeYear()">
                                <a-select-option :value="year" :key="year">{{year}}</a-select-option>
                            </template>
                        </a-select>
                    </a-form-item>
                </a-col>
          <a-col :span="24" style="block">
                   <a-form-item label="Mesiac" :hasFeedback="false">
                        <a-select type="text"       v-decorator="[
                `selectedMonth`,
                { initialValue: selectedMonth }
              ]" >
                       <a-select-option value="" key="0">Celý rok</a-select-option>

                            <template v-for="month in 12">
                                <a-select-option :value="month" :key="month">{{new Date(selectedYear + '-' + month +'-1').toLocaleString('sk-SK',{month:'long'})}}</a-select-option>
                            </template>
                        </a-select>
                    </a-form-item>
        </a-col>
          <a-col :span="24" style="block">
           <a-form-item :hasFeedback="false" label="Číslo objednávky">
           <a-input class="w-100"
       v-decorator="[
                `orderNumber`
              ]"

    />
          </a-form-item>
        </a-col>
            <a-col :span="24" style="block">
           <a-form-item :hasFeedback="false" :hasSuccess="false"  label="Typ platby">
           <a-select
      mode="multiple"
       v-decorator="[
                `orderPayment`
              ]"
    >
      <a-select-option v-for="i in order_payments" :key="i.value">{{i.label}}</a-select-option>
    </a-select>
          </a-form-item>
        </a-col>
          <a-col :span="24" style="block">
           <a-form-item :hasFeedback="false"  label="Stav objednávky">
           <a-select
      mode="multiple"
       v-decorator="[
                `orderStatus`
              ]"
    >
      <a-select-option v-for="i in order_statuses" :key="i.value">{{i.label}}</a-select-option>
    </a-select>
          </a-form-item>
        </a-col>
     <a-col :span="24" style="block">
           <a-form-item :hasFeedback="false"  label="Fulltextové vyhľadávanie">
           <a-input
       v-decorator="[
                `fulltextSearch`
              ]"
    >
    </a-input>
          </a-form-item>
        </a-col>



      </a-row>
      <a-row class="mt-4">
        <a-col :span="24" class="pb-2">
          <a-button  @click="handleResetMF">
            Reštart
          </a-button>
          <a-button type="secondary" :style="{ float: 'right', marginLeft: '8px' }" html-type="submit">
            Filtrovať
          </a-button>
        </a-col>
      </a-row>
    </a-form>
</div>
</div>
</div>
</div>
        </CCardBody>
        </CCard>

                   </CCol>

<a-drawer
  title="Filter"
  placement="right"
  :visible="showMobileFilter"
  @close="showMobileFilter = false"
  :width="300"
  class="d-xl-none"
>
  <a-form class="ant-advanced-search-form" :form="mobileForm" @submit="handleMobileFilter">
    <a-form-item label="Rok">
      <a-select v-decorator="['selectedYear', { initialValue: selectedYear }]">
        <template v-for="year in exposeYear()">
          <a-select-option :value="year" :key="'m'+year">{{year}}</a-select-option>
        </template>
      </a-select>
    </a-form-item>
    <a-form-item label="Mesiac">
      <a-select v-decorator="['selectedMonth', { initialValue: selectedMonth }]">
        <a-select-option value="" key="m0">Celý rok</a-select-option>
        <template v-for="month in 12">
          <a-select-option :value="month" :key="'m'+month">{{new Date(selectedYear + '-' + month +'-1').toLocaleString('sk-SK',{month:'long'})}}</a-select-option>
        </template>
      </a-select>
    </a-form-item>
    <a-form-item label="Číslo objednávky">
      <a-input v-decorator="['orderNumber']" />
    </a-form-item>
    <a-form-item label="Typ platby">
      <a-select mode="multiple" v-decorator="['orderPayment']">
        <a-select-option v-for="i in order_payments" :key="'m'+i.value">{{i.label}}</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item label="Stav objednávky">
      <a-select mode="multiple" v-decorator="['orderStatus']">
        <a-select-option v-for="i in order_statuses" :key="'m'+i.value">{{i.label}}</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item label="Fulltextové vyhľadávanie">
      <a-input v-decorator="['fulltextSearch']" />
    </a-form-item>
    <div class="mt-3">
      <a-button @click="handleMobileReset">Reštart</a-button>
      <a-button type="primary" html-type="submit" style="float:right;">Filtrovať</a-button>
    </div>
  </a-form>
</a-drawer>

<a-modal
  :visible="diagVisible"
  title="Diagnostika objednávky"
  :footer="null"
  :width="760"
  @cancel="diagVisible = false"
>
  <div v-if="diagLoading" class="text-center p-4">
    <a-spin />
  </div>
  <div v-else-if="diag">
    <h4 class="mb-3">Diagnostika objednávky #{{ diag.order && diag.order.order_id }}</h4>

    <p class="mb-1">
      <strong>Napojenie na BONUS:</strong>
      <a-tag :color="diagSynced ? 'green' : 'orange'">
        {{ diagSynced ? 'V BONUSe' : 'nie je v BONUSe' }}
      </a-tag>
    </p>
    <p class="mb-1"><strong>Diagnóza:</strong> <code>{{ diag.flags && diag.flags.diagnosis }}</code></p>
    <p class="mb-1">
      <strong>Callback z banky:</strong>
      <a-tag :color="diag.flags && diag.flags.verify_callback_received ? 'green' : 'orange'">
        {{ diag.flags && diag.flags.verify_callback_received ? 'áno' : 'nie' }}
      </a-tag>
    </p>
    <p class="mb-3">
      <strong>Pokusy o uloženie dokladu:</strong> {{ diag.uloz_doklad_attempts_count || 0 }}
      <span v-if="diag.uloz_doklad_result"> (výsledok: {{ diag.uloz_doklad_result }})</span>
    </p>

    <div v-if="diag.bis_errors && diag.bis_errors.length" class="mb-3">
      <h5 class="text-danger">BIS chyby</h5>
      <div v-for="(e, i) in diag.bis_errors" :key="'err' + i" class="mb-2">
        <div><code>{{ e.endpoint }}</code> - HTTP {{ e.http_code }}</div>
        <pre class="diag-pre">{{ e.response }}</pre>
      </div>
    </div>

    <div v-if="diag.uloz_doklad_attempts && diag.uloz_doklad_attempts.length" class="mb-3">
      <h5>Pokusy o uloženie dokladu tejto objednávky</h5>
      <a-table
        :columns="diagLogColumns"
        :dataSource="diag.uloz_doklad_attempts"
        :rowKey="(row, i) => 'att' + i"
        size="small"
        :pagination="false"
      >
        <template slot="diagResponse" slot-scope="text">
          <pre class="diag-pre">{{ text }}</pre>
        </template>
      </a-table>
    </div>

    <h5>Posledné BIS volania (cardpay, systémovo)</h5>
    <p class="text-muted" style="font-size:12px; margin-bottom:6px;">
      Pozn.: tento zoznam nie je viazaný len na túto objednávku.
    </p>
    <a-table
      v-if="diagLog.length"
      :columns="diagLogColumns"
      :dataSource="diagLog"
      :rowKey="(row, i) => i"
      size="small"
      :pagination="false"
    >
      <template slot="diagResponse" slot-scope="text">
        <pre class="diag-pre">{{ text }}</pre>
      </template>
    </a-table>
    <p v-else class="text-muted">Žiadne záznamy.</p>
  </div>
</a-modal>

<a-modal
  :visible="resendStepsVisible"
  title="Detail odoslania do BONUSu"
  :footer="null"
  :width="760"
  @cancel="resendStepsVisible = false"
>
  <div v-if="resendSteps">
    <p v-if="resendStepsMessage" class="mb-2"><strong>{{ resendStepsMessage }}</strong></p>
    <h5>Kroky (steps)</h5>
    <pre class="diag-pre">{{ prettyJson(resendSteps) }}</pre>
  </div>
  <p v-else class="text-muted">Žiadne detaily.</p>
</a-modal>


                   </CRow>
                   </div>
                   </div>
</template>
<script>
    import {getURL} from "../api";

    import {IMG_URL} from "../api";
    import {dataService} from "../_services";
    import {Button, Input, Icon, Tag} from 'ant-design-vue';

    import moment from 'moment'

    import Vue from "vue"
    import FormItem from 'ant-design-vue'
    import locale from 'ant-design-vue/es/date-picker/locale/sk_SK';
    import 'moment/locale/sk';
    const formItemLayout = {
  labelCol: { span: 7 },
  wrapperCol: { span: 15 },
};
const formTwoLayout = {
  labelCol: { span: 10 },
  wrapperCol: { span: 12 },
};

Vue.use(FormItem);
    var locale2 = {
        "lang": {
            "placeholder": "Vybrať dátum",
            "rangePlaceholder": ["Začiatok", "Koniec"],
            "today": "Dnes",
            "now": "Teraz",
            "backToToday": "Späť na dnes",
            "ok": "Ok",
            "clear": "Vymazať",
            "month": "Mesiac",
            "year": "Rok",
            "timeSelect": "Vybrať čas",
            "dateSelect": "Vybrať dátum",
            "monthSelect": "Vybrať mesiac",
            "yearSelect": "Vybrať rok",
            "decadeSelect": "Vybrať dekádu",
            "yearFormat": "YYYY",
            "dateFormat": "M/D/YYYY",
            "dayFormat": "D",
            "dateTimeFormat": "M/D/YYYY HH:mm:ss",
            "monthFormat": "MMMM",
            "monthBeforeYear": true,
            "previousMonth": "Predchádzajúci mesiac (PageUp)",
            "nextMonth": "Nasledujúci mesiac (PageDown)",
            "previousYear": "Minulý rok (Control + left)",
            "nextYear": "Nasledujúci rok (Control + right)",
            "previousDecade": "Minulá dekáda",
            "nextDecade": "Nasledujúca dekáda",
            "previousCentury": "Minulé storočie",
            "nextCentury": "Nasledujúce storočie"
        },
        "timePickerLocale": {
            "placeholder": "Vybrať čas"
        },
        "dateFormat": "DD.MM.YYYY",
        "dateTimeFormat": "DD.MM.YYYY HH:mm:ss",
        "weekFormat": "YYYY-wo",
        "monthFormat": "MMMM YYYY"
    }
    export default {
        name: "deskreservations",
        components: {
            "a-button": Button,
            "a-icon": Icon,
            "a-tag": Tag,
            "a-input": Input
        },
        data() {
            return {
              data: [],
              url: getURL(),
                bonusEnabled: false,
                knownStatuses: ['pending', 'payment_recieved', 'in_checkout', 'storno', 'abandoned', 'shiped', 'instock', 'completed'],
                formItemLayout,
                formTwoLayout,
                roomModal: false,
                loadingExport:false,
                showMobileFilter: false,
                diagVisible: false,
                diagLoading: false,
                diag: null,
                resendingMap: {},
                bulkResending: false,
                resendStepsVisible: false,
                resendSteps: null,
                resendStepsMessage: '',
                diagLogColumns: [
                  { title: 'Endpoint', dataIndex: 'endpoint', width: 220 },
                  { title: 'HTTP', dataIndex: 'http_code', width: 80 },
                  { title: 'Odpoveď', dataIndex: 'response_data', scopedSlots: { customRender: 'diagResponse' } }
                ],
                checkorder:{},
                pickExpandedKeys: [],
                loading:true,
                searchText: '',
                newReservation: {},
pickOrderColumns: [
  { title: '#', dataIndex: 'order_id', width: 90, scopedSlots: { customRender: 'pickOrderId' } },
  { title: 'Meno', dataIndex: 'name', width: 220 },
{ title: 'Kontakt', dataIndex: 'phone', width: 240, scopedSlots: { customRender: 'pickContact' } },

  { title: 'Faktúra', dataIndex: 'invoice', width: 130, scopedSlots: { customRender: 'pickInvoice' } },
  { title: 'Doprava', dataIndex: 'shippingLabel', width: 140 },
  { title: 'Miesto doručenia', dataIndex: 'shippingVariant', width: 160, scopedSlots: { customRender: 'pickPickup' } },
  { title: 'Suma', dataIndex: 'price', width: 110, scopedSlots: { customRender: 'pickPrice' } },
  { title: 'Vytvorené', dataIndex: 'created', width: 160, scopedSlots: { customRender: 'pickCreated' } }
],


pickProductColumns: [
  { title: '', dataIndex: 'picked', width: 40, scopedSlots: { customRender: 'picked' } },
  { title: 'Produkt', dataIndex: 'title', scopedSlots: { customRender: 'product' } },
  { title: 'EAN', dataIndex: 'ean', width: 150, scopedSlots: { customRender: 'ean' } },
  { title: 'Sklad', dataIndex: 'sklad', width: 90, scopedSlots: { customRender: 'sklad' } },
  { title: 'Skladom', dataIndex: 'skladombb', width: 120, scopedSlots: { customRender: 'skladombb' } }
],

                searchInput: null,
                exportFormat: '',
                action:undefined,
                  activeTab: 'orders',
  pickedMap: {}, // { "954:267000": true, ... }
                IMG_URL,
                selectedRowKeys: [],
                permissions:[],
                vars: {},
                 pickColumns: [
    { title: '', dataIndex: 'picked', width: 40, scopedSlots: { customRender: 'picked' } },
    { title: 'Produkt', dataIndex: 'product', scopedSlots: { customRender: 'product' } },
    { title: 'Objednávka', dataIndex: 'order', width: 260, scopedSlots: { customRender: 'order' } },
    { title: 'Doprava / výdajné miesto', dataIndex: 'shipping', width: 320, scopedSlots: { customRender: 'shipping' } },
    { title: 'Vytvorené', dataIndex: 'createdLabel', width: 160 }
  ],
                actions: [],
                concepts:[],
                productsinorder: false,
                locale2,
                years:[],
                selectedYear:  parseInt(new Date().getFullYear()),
                selectedMonth: "",
                reservationModal:false,
                filteredprice:false,
                filteredabbprice:false,
                expand: false,
                form: this.$form.createForm(this, { name: 'advanced_search' }),
                mobileForm: this.$form.createForm(this, { name: 'mobile_search' }),
                roleops: [],
                locale,
                order_statuses: [
                    {"value": "pending","label": "Objednávka"},
                    {"value": "payment_recieved","label": "Prijatá platba"},
                    {"value": "completed","label": "Kompletná"},
                    {"value": "abandoned","label": "Opustená objednávka"},
                    {"value": "in_checkout","label": "Na platobnej bráne"},
                    {"value": "storno","label": "Stornovaná objednávka"},
                    ],
                    order_payments: [
                    {"value": "cod","label": "Platba na mieste"},
                    {"value": "card","label": "Platba kartou"},
                    {"value": "bank","label": "Platba bankovým prevodom"},
                    {"value": "paylater","label": "Platba na splátky"},
                    ],
                colorsto: JSON.parse(localStorage.colors),
                user: JSON.parse(localStorage.user),
                 dateFormat: 'DD.MM.YYYY',
                currentPage: 1,
                pageSize: 20,
                totalOrders: 0,
                columns2: [
                {
                    title: 'č. obj.',
                    dataIndex: 'order_id',
                        width: '5%',
                },
                {
                    title: 'Dátum vytvorenia',
                    dataIndex: 'created',
                    scopedSlots: {customRender: 'date'},
                    width: '10%'
                },
                {
                    title: 'Zákazník',
                    dataIndex: 'name',
                    scopedSlots: {customRender: 'user'},
                    width: '10%',
                },
                {
                    title: 'Poznámka',
                    align: 'center',
                    dataIndex: 'note',
                    width: '10%',
                },
                {
                    align: 'right',
                    scopedSlots: {customRender: 'name'},
                }
                ],
                baseColumns: [
                    {
                        title: '#',
                        dataIndex: 'order_id',
                        width: 70
                    },  {
                        title: 'Meno',
                        dataIndex: 'name',
                        width: '15%',
                        scopedSlots: {customRender: 'namevo'},
                    },
                    {
                        title: 'Kontakt',
                        dataIndex: 'phone',
                        width: 80,
                        scopedSlots: {customRender: 'phones'},
                    },
                     {
                        title: 'Doprava',
                        dataIndex: 'shipping',
                        width: 120,
                        scopedSlots: {customRender: 'shipping'},
                    },
                    {
                        title: 'Typ platby',
                        dataIndex: 'payment_method',
                        width: 120,
                        scopedSlots: {customRender: 'payment'},
                    },
                    {
                        title: 'Poznámka',
                        dataIndex: 'note',
                        width: 90,
                        align: 'center',
                        scopedSlots: {customRender: 'field_4'},
                    },
                     {
                        title: 'Suma',
                        dataIndex: 'price',
                        width: '10%',
                        scopedSlots: {customRender: 'prices'},
                    },
                    {
                        title: 'Stav',
                        dataIndex: 'order_status',
                        width: '10%',
                        scopedSlots: {customRender: 'status'},
                    },
                    {
                        title: 'Vytvorené',
                        dataIndex: 'created',
                        width: 140,
                        scopedSlots: {customRender: 'date'},
                    },
                    {
                        align: 'right',
                        width: 80,
                        scopedSlots: {customRender: 'name'},
                    }
                ],
            };

        },
computed: {
columns() {
  // Ak je web napojený na BONUS, pridáme stĺpec CRM za stĺpec Stav
  if (!this.bonusEnabled) return this.baseColumns;
  const cols = this.baseColumns.slice();
  const idx = cols.findIndex(c => c.dataIndex === 'order_status');
  const crmCol = {
    title: 'CRM',
    dataIndex: 'bis_synced',
    width: 130,
    scopedSlots: { customRender: 'crm' }
  };
  if (idx === -1) cols.push(crmCol);
  else cols.splice(idx + 1, 0, crmCol);
  return cols;
},
diagLog() {
  // Rôzne názvy poľa naprieč endpointom - použijeme prvé neprázdne
  if (!this.diag) return [];
  return this.diag.bis_api_log_cardpay_recent
      || this.diag.bis_api_log
      || this.diag.bis_api_log_recent
      || [];
},
diagSynced() {
  // Zdroj pravdy pre napojenie na BONUS je flags.bis_synced z detailu.
  return !!(this.diag && this.diag.flags && this.diag.flags.bis_synced);
},
unsyncedOrders() {
  // Viditeľné objednávky, ktoré nie sú napojené na BONUS.
  // Vynechávame opustené a platby kartou bez prijatej platby (doposlanie tam nedáva zmysel).
  return (this.data || []).filter(o =>
    o && o.bis_synced != 1 && o.order_status !== 'abandoned' && this.canResendToBis(o)
  );
},
pagination() {
  return {
    current: this.currentPage,
    pageSize: this.pageSize,
    total: this.totalOrders,
    showSizeChanger: true,
    pageSizeOptions: ['20', '50', '100'],
    showTotal: (total) => `Celkom ${total} objednávok`,
  };
},
pickOrders() {
  return (this.data || [])
    .filter(o => o && o.order_status === 'payment_recieved')
    .map(o => {
      const ship = o.shipping || {};
      let variant = ship.variant || '';
      
      // Ak nemáme výdajné miesto a je to pošta/balík na adresu, zobrazíme dodaciu adresu
      if (!variant && o.orderdata) {
        const shipment = ship.shipment || '';
        if (shipment.indexOf('balikposta') > -1 || shipment.indexOf('balikadresa') > -1) {
          try {
            const od = typeof o.orderdata === 'string' ? JSON.parse(o.orderdata) : o.orderdata;
            if (od.same === 'same' || !od.delivery_street1) {
              variant = [od.billing_street1, od.billing_postal_code, od.billing_city].filter(Boolean).join(', ');
            } else {
              variant = [od.delivery_street1, od.delivery_postal_code, od.delivery_city].filter(Boolean).join(', ');
            }
          } catch(e) { /* ignore */ }
        }
      }

      return {
        ...o,
        shippingLabel: this.humanizeShipping(ship, o),
        shippingVariant: variant,
        shippingVariantID: ship.variantID || '',
        tracking: ship.tracking || ''
      };
    });
},


         rowSelection() {
                const { selectedRowKeys } = this;
                return {
                    selectedRowKeys,
                    onChange: this.onSelectChange,
                    hideDefaultSelections: true,
                    onSelection: this.onSelection,
                };
            },
             pickRows() {
    // len pending + payment_recieved
    const allowed = { pending: true, payment_recieved: true };
    const rows = [];

    (this.data || []).forEach(order => {
      if (!order || !allowed[order.order_status]) return;

      const ship = order.shipping || {};
      const shippingLabel = this.humanizeShipping(ship, order);

      const products = order.products || [];
      products.forEach(p => {
        if (!p) return;

        const key = String(order.order_id) + ':' + String(p.id);

        rows.push({
          key,
          order_id: order.order_id,
          order_status: order.order_status,
          createdLabel: this.formatDate(order.created),

          customer_name: order.name || '',
          phone: order.phone || '',
          email: order.email || '',

          shippingLabel,
          variant: ship.variant || '',
          variantID: ship.variantID || '',
          tracking: ship.tracking || '',

          product_id: p.id,
          title: p.title || '',
          url: p.url || (p.data ? p.data.url : ''),
          siteUrl: p.siteUrl || (p.data ? p.data.siteUrl : ''),
          language: p.language || (p.data ? p.data.language : 'sk'),
          ean: (p.data && p.data.ean) ? p.data.ean : p.ean,
          sklad: (p.data && p.data.sklad) ? p.data.sklad : p.sklad,
          skladombb: (p.data && p.data.skladombb) ? p.data.skladombb : p.skladombb,
          count: parseInt(p.count, 10) || 1
        });
      });
    });

    return rows;
  }
  },
        mounted() {
        /*    dataService.axiosFetch("roles").then(results => {



this.actions.push({"value":"export","label":"Exportovať do PDF"});


                results.forEach(obj => {
                    var iid = obj.id;
                    var vval = obj.title;
                    this.roleops[iid] = vval;


                });
            });*/
            this.$nextTick(() => {
              this.PostFetch();
this.loadPicked();
            })
            this.loadBonusEnabled();

        },
        methods: {
            // Zistí, či je web napojený na BONUS (variable so slugom bonussyskod)
            loadBonusEnabled() {
                dataService.axiosFetch('variable/bonussyskod').then(r => {
                    let val = null;
                    if (r != null) {
                        if (typeof r === 'object') {
                            val = r.bonussyskod != null ? r.bonussyskod : (r.value != null ? r.value : null);
                        } else {
                            val = r;
                        }
                    }
                    this.bonusEnabled = val != null && String(val).trim() !== '';
                }).catch(() => {
                    this.bonusEnabled = false;
                });
            },
          expandedProducts(order) {
  const productColumns = [
    { title: '', dataIndex: 'picked', width: 40,
      customRender: (val, row) => {
        const key = row._pickKey;
        return (
          <a-checkbox
            checked={this.isPicked(key)}
            onChange={e => this.setPicked(key, e.target.checked)}
          />
        );
      }
    },
    { title: 'Produkt', dataIndex: 'title',
      customRender: (val, row) => {
        return (
          <div>
            <div>
              {row.count > 1 ? <b>{row.count} x </b> : null}
              <router-link class="text-dark" to={'/edit-content/' + row.id}>{row.title}</router-link>
              {row.url ? (
                <a href={row.siteUrl + '/' + row.language + '/' + row.url} target="_blank" class="ml-2" style="font-size:10px;color:#777;">
                  <i class="fas fa-external-link-alt"></i>
                </a>
              ) : null}
            </div>
            <div style="font-size:11px;color:#666;">
              {row.ean}
              {row.skladombb ? (' - ' + row.skladombb) : ''}
              {row.sklad ? (' - ' + row.sklad) : ''}
            </div>
          </div>
        );
      }
    },
    { title: 'Poznámka k doprave', dataIndex: 'shippingInfo',
      customRender: () => {
        return (
          <div style="font-size:11px;color:#666;">
            {order.shippingVariant ? <div>{order.shippingVariant}</div> : null}
            {order.shippingVariantID ? <div>ID: {order.shippingVariantID}</div> : null}
            {order.tracking ? <div><a href={order.tracking} target="_blank">tracking</a></div> : null}
          </div>
        );
      }
    }
  ];

  const products = (order.products || []).map(p => {
    const key = String(order.order_id) + ':' + String(p.id);
    const d = p.data || {};
    return {
      ...p,
      _pickKey: key,
      title: p.title || '',
      url: p.url || d.url || '',
      siteUrl: p.siteUrl || d.siteUrl || '',
      language: p.language || d.language || 'sk',
      ean: d.ean || p.ean || '',
      sklad: d.sklad || p.sklad || '',
      skladombb: d.skladombb || p.skladombb || '',
      count: parseInt(p.count, 10) || 1
    };
  });

  // render nested table
  return (
    <a-table
      columns={productColumns}
      dataSource={products}
      rowKey={row => row._pickKey}
      pagination={false}
      size="small"
      class="nested-products-table"
    />
  );
},
parseSkladCode(code) {
  const s = (code || '').toString().trim();
  if (!s) return { empty: true, prefix: 'ZZZ', num: 999999, raw: '' };

  const m = s.match(/^([A-Za-z]+)\s*0*([0-9]+)$/);
  if (m) {
    return {
      empty: false,
      prefix: (m[1] || '').toUpperCase(),
      num: parseInt(m[2], 10) || 0,
      raw: s
    };
  }

  return { empty: false, prefix: s.toUpperCase(), num: 999999, raw: s };
},

compareSklad(a, b) {
  const A = this.parseSkladCode(a);
  const B = this.parseSkladCode(b);

  if (A.empty && !B.empty) return 1;
  if (!A.empty && B.empty) return -1;

  if (A.prefix < B.prefix) return -1;
  if (A.prefix > B.prefix) return 1;

  if (A.num < B.num) return -1;
  if (A.num > B.num) return 1;

  // fallback (napr. PC05A vs PC05B)
  if (A.raw < B.raw) return -1;
  if (A.raw > B.raw) return 1;

  return 0;
},

          isPicked(key) {
    return !!this.pickedMap[key];
  },
  setPicked(key, val) {
    // aby bola reaktivita istá aj pri novom kľúči
    this.$set(this.pickedMap, key, !!val);
    localStorage.setItem('orders_picked_map', JSON.stringify(this.pickedMap));
  },
  loadPicked() {
    try {
      const raw = localStorage.getItem('orders_picked_map');
      if (raw) this.pickedMap = JSON.parse(raw) || {};
    } catch (e) {
      this.pickedMap = {};
    }
  },
  syncPickExpanded() {
  this.pickExpandedKeys = (this.pickOrders || []).map(o => String(o.order_id));
},
onPickExpandedChange(keys) {
  // ak chceš dovoliť ručne zbaliť/rozbaliť
  this.pickExpandedKeys = (keys || []).map(k => String(k));
},

orderProductRows(order) {
  const out = [];
  const products = (order && order.products) ? order.products : [];

  products.forEach(p => {
    const d = p.data || {};
    out.push({
      ...p,
      _pickKey: String(order.order_id) + ':' + String(p.id),
      title: p.title || '',
      url: p.url || d.url || '',
      siteUrl: p.siteUrl || d.siteUrl || '',
      language: p.language || d.language || 'sk',
      ean: d.ean || p.ean || '',
      sklad: d.sklad || p.sklad || '',
      skladombb: d.skladombb || p.skladombb || '',
      count: parseInt(p.count, 10) || 1
    });
  });

 out.sort((x, y) => {
  const s = this.compareSklad(x.sklad, y.sklad);
  if (s !== 0) return s;

  const t1 = (x.title || '').toString().toLowerCase();
  const t2 = (y.title || '').toString().toLowerCase();
  if (t1 < t2) return -1;
  if (t1 > t2) return 1;

  return 0;
});

return out;
},
invoiceUrl(path) {
  const p = (path || '').toString().replace(/^\/+/, '');
  const base = String(this.url.API_URL || '').replace(/\/api\/v1\/?$/, '');
  return base + '/' + p;
},

  humanizeShipping(shipping, record) {
    const s = (shipping && shipping.shipment) ? String(shipping.shipment) : '';

    if (s.length === 1) return 'Osobný odber';
    if (s === 'sps-parcel-shop') return 'Balíkovo';
    if (record && record.payment_method === 'cod') return 'Dobierka';
    if (s === 'packeta-5' || s === 'packeta-10' || s === 'packeta-15') return 'Packeta';
    if (s === 'dpd-5') return 'DPD';
    if (s === 'cod') return 'Osobný odber';
    if (s === 'balikadresa-5' || s === 'balikadresa-10' || s === 'balikadresa-15') return 'Balík na adresu';
    if (s === 'balikposta-5' || s === 'balikposta-10' || s === 'balikposta-15') return 'Slovenská pošta';

    return s || '—';
  },
          redo(order_id,invoice_id,created)
          {

          let year = this.formatYear(created);

 dataService.axiosFetch("invoice/" + order_id + "/true/" + invoice_id + "/" + year);

          },
          onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },handleFilter(e) {
    e.preventDefault();
    this.currentPage = 1;
    this.showMobileFilter = false;
    this.PostFetch();
},
handleTableChange(pagination) {
    this.currentPage = pagination.current;
    this.pageSize = pagination.pageSize;
    this.PostFetch();
},
handleResetMF() {
      this.form.resetFields();
      this.currentPage = 1;
      this.showMobileFilter = false;
      this.PostFetch();
    },
handleMobileFilter(e) {
    e.preventDefault();
    this.mobileForm.validateFields((err, values) => {
      if (!err) {
        // sync mobile form values to desktop form
        this.form.setFieldsValue(values);
        this.currentPage = 1;
        this.showMobileFilter = false;
        this.PostFetch();
      }
    });
},
handleMobileReset() {
    this.mobileForm.resetFields();
    this.form.resetFields();
    this.currentPage = 1;
    this.showMobileFilter = false;
    this.PostFetch();
},
     PostFetch()
    {
this.form.validateFields((err, values) => {
        if (!err) {
   this.loading = true;
   this.filteredprice = 0;
   this.filteredabbprice = 0;

   values.page = this.currentPage;
   values.pageSize = this.pageSize;

                dataService.axiosPost('getallorders',values).then(results => {
                    var res = results.data.data;
                    this.data = res.data;
                    
                    if (res.pagination) {
                      this.totalOrders = res.pagination.total;
                      this.currentPage = res.pagination.page;
                    }

                    this.loading = false;

                    this.filteredprice = res.filteredprice || 0;
                    this.filteredabbprice = res.filteredabbprice || 0;
this.syncPickExpanded();
                });
        }
        });
    },
          exposeYear()
    {

let years = [];
var fromyear = parseInt(new Date().getFullYear()) - 10;
var toyear = parseInt(new Date().getFullYear());

for(let year = fromyear; year <= toyear; year++){ years.push(year) }

return years;
    },
            showDiagnostics(order_id) {
                this.diag = null;
                this.diagLoading = true;
                this.diagVisible = true;
                dataService.axiosFetch('orderdiagnostics', order_id).then(data => {
                    // axiosFetch vracia už rozbalené results.data.data
                    this.diag = data || null;
                    if (this.diag) {
                        if (!this.diag.bis_errors) this.$set(this.diag, 'bis_errors', []);
                        if (!this.diag.bis_api_log) this.$set(this.diag, 'bis_api_log', []);
                        if (!this.diag.flags) this.$set(this.diag, 'flags', {});
                    }
                    this.diagLoading = false;
                }).catch(() => {
                    this.diagLoading = false;
                });
            },

            isResending(order_id) {
                return !!this.resendingMap[order_id];
            },

            // Známe hodnoty dopravy (namapované v šablóne)
            knownShipment(shipping, record) {
                if (!shipping) return false;
                const s = shipping.shipment;
                if (s == null) return false;
                if (String(s).length === 1) return true;              // Osobný odber
                if (record && record.payment_method == 'cod') return true; // Dobierka
                const known = [
                    'sps-parcel-shop', 'dpd-5', 'cod',
                    'packeta-5', 'packeta-10', 'packeta-15',
                    'balikadresa-5', 'balikadresa-10', 'balikadresa-15',
                    'balikposta-5', 'balikposta-10', 'balikposta-15'
                ];
                return known.indexOf(s) !== -1;
            },
            // Doprava, ktorú v šablóne nemapujeme - zobrazíme surovú hodnotu ako fallback
            isUnknownShipment(shipping, record) {
                return !!(shipping && shipping.shipment) && !this.knownShipment(shipping, record);
            },
            shippingLabelFallback(shipping) {
                return (shipping && shipping.shipment) ? String(shipping.shipment) : '';
            },

            // Platba prijatá? (podľa príznaku alebo stavu objednávky)
            isPaymentReceived(record) {
                return record && (record.payment_received_flag == 1 || record.order_status === 'payment_recieved');
            },

            // Platba kartou? (cardpay / webpay / payout / tatrapayplus)
            isCardPayment(record) {
                if (!record) return false;
                return ['cardpay', 'webpay', 'payout', 'tatrapayplus'].indexOf(record.payment_method) !== -1;
            },

            // Doposlať do BONUSu dovolíme, okrem: platba kartou, ktorá ešte nie je prijatá
            canResendToBis(record) {
                if (this.isCardPayment(record) && !this.isPaymentReceived(record)) return false;
                if (this.isEffectivelyAbandoned(record)) return false;
                return true;
            },

            // Platba kartou > 1 hodina bez prijatej platby => považujeme za opustenú
            isEffectivelyAbandoned(record) {
                if (!record) return false;
                if (record.order_status === 'abandoned') return false; // už je označená priamo
                if (!this.isCardPayment(record)) return false;
                if (this.isPaymentReceived(record)) return false;
                if (!record.created) return false;
                // created je unix timestamp (v sekundách)
                const createdMs = Number(record.created) * 1000;
                if (isNaN(createdMs)) return false;
                return (Date.now() - createdMs) > 3600 * 1000; // viac ako 1 hodina
            },

            prettyJson(val) {
                try {
                    return typeof val === 'string' ? val : JSON.stringify(val, null, 2);
                } catch (e) {
                    return String(val);
                }
            },

            showResendSteps(steps, message) {
                this.resendSteps = steps || null;
                this.resendStepsMessage = message || '';
                this.resendStepsVisible = true;
            },

            // Nízkoúrovňové volanie resend endpointu. Vracia rozbalený objekt odpovede (status, message, ...).
            callResend(order_id, force) {
                const url = 'resendtobis/' + order_id + (force ? '?force=1' : '');
                return dataService.axiosFetch(url);
            },

            // Spracovanie jednej objednávky s toastami. Vracia Promise so statusom odpovede.
            resendToBis(record, force) {
                const order_id = record.order_id;
                if (this.isResending(order_id)) return Promise.resolve(null);
                this.$set(this.resendingMap, order_id, true);

                return this.callResend(order_id, force).then(res => {
                    this.$set(this.resendingMap, order_id, false);
                    if (!res || !res.status) {
                        this.$message.error('Neočakávaná odpoveď zo servera pri odosielaní do BONUSu.');
                        return null;
                    }
                    this.handleResendResult(record, res);
                    return res;
                }).catch(() => {
                    this.$set(this.resendingMap, order_id, false);
                    this.$message.error('Chyba pri komunikácii so serverom (BONUS).');
                    return null;
                });
            },

            handleResendResult(record, res) {
                if (res.status === 'ok') {
                    // Prepni riadok na "V BONUSe"
                    this.$set(record, 'bis_synced', 1);
                    if (res.dokladID) this.$set(record, 'bis_doklad_id', res.dokladID);

                    let msg = res.message || ('Objednávka ' + res.order_id + ' odoslaná do BONUSu');
                    if (res.dokladID) msg += ' (doklad ' + res.dokladID + ')';
                    if (res.items_total !== undefined && res.items_ok !== undefined && res.items_ok < res.items_total) {
                        this.$message.warning(msg + ' - časť položiek sa neuložila (' + res.items_ok + '/' + res.items_total + ').', 6);
                    } else {
                        this.$message.success(msg);
                    }
                } else if (res.status === 'skipped') {
                    // Ponúkni force akciu cez potvrdenie
                    this.$message.info(res.message || 'Objednávka už má BIS doklad.', 6);
                } else {
                    // error - toast + možnosť zobraziť steps
                    this.$message.error(res.message || 'Odoslanie do BONUSu zlyhalo.', 8);
                    if (res.steps) {
                        this.showResendSteps(res.steps, res.message);
                    }
                }
            },

            // Hromadné sekvenčné doposlanie nenapojených objednávok
            async resendAllUnsynced() {
                const list = this.unsyncedOrders.slice();
                if (!list.length) {
                    this.$message.info('Žiadne nenapojené objednávky.');
                    return;
                }
                this.bulkResending = true;
                const total = list.length;
                let done = 0, okCount = 0, skippedCount = 0, errorCount = 0;
                this.$message.loading({ content: 'Doposielam 0/' + total + '...', key: 'bulkResend', duration: 0 });

                for (const record of list) {
                    // Preskoč, ak sa medzičasom napojila
                    if (record.bis_synced == 1) { done++; continue; }
                    const res = await this.resendToBisSilent(record, false);
                    if (res && res.status === 'ok') okCount++;
                    else if (res && res.status === 'skipped') skippedCount++;
                    else errorCount++;
                    done++;
                    this.$message.loading({ content: 'Doposielam ' + done + '/' + total + '...', key: 'bulkResend', duration: 0 });
                    // Malá pauza, aby sme nezahltili BIS
                    await new Promise(r => setTimeout(r, 300));
                }

                this.$message.success({
                    content: 'Hotovo: ' + okCount + ' ok, ' + skippedCount + ' preskočené, ' + errorCount + ' chýb.',
                    key: 'bulkResend',
                    duration: 5
                });
                this.bulkResending = false;
            },

            // Verzia pre hromadné spracovanie - aktualizuje riadok, ale nespúšťa individuálne toasty.
            resendToBisSilent(record, force) {
                const order_id = record.order_id;
                this.$set(this.resendingMap, order_id, true);
                return this.callResend(order_id, force).then(res => {
                    this.$set(this.resendingMap, order_id, false);
                    if (res && res.status === 'ok') {
                        this.$set(record, 'bis_synced', 1);
                        if (res.dokladID) this.$set(record, 'bis_doklad_id', res.dokladID);
                    }
                    return res;
                }).catch(() => {
                    this.$set(this.resendingMap, order_id, false);
                    return null;
                });
            },

            resendEmails(order_id)
            {
                dataService.axiosFetch('sendall',order_id).then(() => {

                });
            },
            formatDate: function (dt) {
                return moment.unix(dt).format('D.M.YYYY H:mm')


            },
            exportInvoices()
            {
this.form.validateFields((err, values) => {


if(this.selectedRowKeys)
values.selectedRowKeys = this.selectedRowKeys;


dataService.axiosPost('export/invoices/'+this.exportFormat,values).then(results => {
                  if(this.exportFormat == 'pohoda')
                  {
    let byte = results.data[0];
    var reportName = 'export.xml';
                    var blob = new Blob([byte], {type: "application/xml"});
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    var fileName = reportName;
    link.download = fileName;
    link.click();
                    }
                    else
                    {
                        const byteCharacters = atob(results.data.data.file);
                        const byteNumbers = new Array(byteCharacters.length);
for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
}
                        const byteArray = new Uint8Array(byteNumbers);
    var reportNames = results.data.data.filename;
       var blobs = new Blob([byteArray], {type: "application/pdf"});
    var links = document.createElement('a');
    links.href = window.URL.createObjectURL(blobs);
    var fileNames= reportNames;
    links.download = fileNames;
    links.click();
                    }
                });
            });
            },

            doAction()
                {
                    if(this.action)
                    {
if(this.form)
{
                      this.form.validateFields((err, values) => {
this.loadingExport = true;
                    dataService.axiosPost('export/orders/' + this.action, { 'orders' : this.rowSelection.selectedRowKeys, 'month': values.selectedMonth, 'year':values.selectedYear}).then((results) => {
                        this.rowSelection.selectedRowKeys = [];
                        this.selectedRowKeys =  [];
                        if(this.action === "export")
                        {
                          this.forcePDFDownload(results.data.data);
                        }
                        if(this.action === "exportxls")
                        {
                          this.forceXLSDownload(results.data.data);
                        }
this.loadingExport = false;
                    });
                   });
                   }
                  }
                },
                forceXLSDownload(response){

var arrBuffer = this.base64ToArrayBuffer(response.file);
               const url = window.URL.createObjectURL(new Blob([arrBuffer], {type:"application/vnd.ms-excel"}))


               const link = document.createElement('a')
               link.href = url
               link.setAttribute('download', response.filename) //or any other extension
               document.body.appendChild(link)
               link.click()
           },
                forcePDFDownload(response){

var arrBuffer = this.base64ToArrayBuffer(response.file);
               const url = window.URL.createObjectURL(new Blob([arrBuffer], {type:"application/pdf"}))


               const link = document.createElement('a')
               link.href = url
               link.setAttribute('download', response.filename) //or any other extension
               document.body.appendChild(link)
               link.click()
           },
            formatYear: function (dt) {
                return moment.unix(dt).format('YYYY')

            },
            handleSearch(selectedKeys, confirm) {
                confirm();
                this.searchText = selectedKeys[0];

            },

            handleReset(clearFilters) {
                clearFilters();
                this.searchText = '';
            },
            fetch() {
                this.loading = true;
                dataService.axiosFetch('getallorders').then(results => {
                    this.data = results;
                    this.loading = false;

                });
            }

        },
    };
</script>

<style>
    ul.ant-pagination {
        margin-top: 0;
        margin-bottom: 1em;
    }


    .product {
        width: 100%;
        clear: both
    }

    .product h4 {
        margin: 0;
        font-size: 12px;
    }
    .paid
    {font-size:12px;
    font-weight:bold;}

    .product h4.type-product {
        font-size: 12px;
    }
.ant-advanced-search-form .ant-form-item
{margin-bottom:0;}
    .product h4.type-voucher {
        display: none
    }

    .wrong1 {
        color: red !important
    }

    .ant-popover-inner-content
    {max-width:350px}

    .product h4 span {
        float: right;
        font-size: 12px;
        padding-top: 5px;
    }

    .product p {
        font-size: 12px;
        font-weight: 400;
        margin-bottom: 2px;
        color: #000000;

    }


    .product:not(.item-0) h4 {
        padding-top: 2px;
    }


.abandoned
{color:#ccc;}
    .ant-pagination5-item-link.ant-pagination5-disabled a {
        color: #8898aa;
        pointer-events: none;
        cursor: auto;
        background-color: #fff;
        border-color: #dee2e6;
    }

@media (max-width: 1199px) {
  .filter-side {
    margin-top: 0;
  }
  .ant-table-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .edit-card .ant-card-head-wrapper {
    flex-direction: column;
    align-items: stretch;
  }
  .edit-card .ant-card-extra {
    margin-left: 0;
    padding: 4px 0;
  }
  .edit-card .ant-card-head-title {
    min-height: auto !important;
    padding: 8px 0;
    width: 100%;
  }
  .orders-title {
    font-size: 18px;
  }
}
.filter-panel{background:#fff;border:1px solid #e8e8e8;border-radius:4px;box-shadow:0 1px 2px rgba(0,0,0,.04);margin-top:20px}
.filter-head{display:flex;align-items:center;justify-content:space-between;padding:10px 14px;border-bottom:1px solid #f0f0f0}
.filter-title{font-size:14px;font-weight:600;color:#0f172a}

.orders-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

@media (max-width: 575px) {
  .container-fluid {
    padding-left: 8px;
    padding-right: 8px;
  }
  .pr-2 {
    padding-right: 8px !important;
  }
  .row, .c-main .row {
    margin-left: 0;
    margin-right: 0;
  }
  .ant-table-small > .ant-table-content > .ant-table-body {
    margin: 0;
  }
  ul.ant-pagination {
    flex-wrap: wrap;
  }
  ul.ant-pagination li {
    margin-bottom: 4px;
  }
}

/* Pick orders table - order separation */
.pick-orders-wrap .ant-table-tbody > tr.ant-table-row {
  border-top: 2px solid #d9d9d9;
}
.pick-orders-wrap .ant-table-tbody > tr.ant-table-row:first-child {
  border-top: none;
}
.pick-orders-wrap .ant-table-expanded-row {
  background-color: transparent !important;
}
.pick-orders-wrap .ant-table-expanded-row > td {
  background-color: transparent !important;
  padding: 4px 8px 12px 8px !important;
  border-bottom: 2px solid #d9d9d9;
}
.pick-orders-wrap .nested-products-table .ant-table-thead {
  display: none;
}

.diag-pre {
  background: #f6f8fa;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 8px;
  margin: 4px 0 0;
  font-size: 12px;
  max-height: 220px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
